<template>
  <CCard>
    <CCardHeader>
      <strong>In-App Popup Banner</strong>
    </CCardHeader>
    <CCardBody>
      <CRow v-if="promotion.image">
        <CCol sm="12" >
          <img :src="img_url" style="width: 300px" />
          <CButton color="danger" @click="removeImage">Remove Banner</CButton>
        </CCol>
      </CRow>
        <CRow v-else>
          <CCol>
             <span>No Popup is set currently</span>
          </CCol>
         
        </CRow>

        <CInputFile
          vertical
          ref="file"
          type="file"
          id="file"
          @change="onImageChange"
        />
        <!--<input type="file" class="form-control" v-on:change="onImageChange">-->
        <label class="text-danger"
          >(Image Size should be (541 X 627) and less than 1 MB)</label
        ><br />
      </CRow>
    </CCardBody>
    <CCardFooter>
      <CButton @click="onSubmit" color="primary">
        <CIcon name="cil-check-circle" />Update Banner
      </CButton>
    </CCardFooter>
  </CCard>
</template>

<script>
const ADMIN_URL = process.env.VUE_APP_ADMIN_URL;
const ROOT_URL = process.env.VUE_APP_ROOT_URL;
const id = window.location.pathname.split("/").pop();
export default {
  name: "PromotionEdit",
  data() {
    return {
      promotion: {},
      img_url: "",
    };
  },
  created() {
    this.getPromotion();
  },
  methods: {
    getPromotion() {
      this.$axios
        .get(`${ADMIN_URL}/promotions/1`)
        .then((response) => {
          console.log(response.data);
          this.promotion = response.data.data;
          this.img_url = ROOT_URL + "/" + this.promotion.image;
        })
        .catch((e) => {
          console.log("error occurs", e);
        });
    },
    onImageChange(e) {
      const file = e[0];
      if (file === undefined) {
        return;
      }
      this.promotion.image = file;
      this.img_url = URL.createObjectURL(file);
    },
    removeImage(e) {
      (this.img_url = ""), (this.promotion.image = "");
      this.onSubmit(e);
    },
    onSubmit(e) {
      e.preventDefault();
      let currentObj = this;
      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Accept: "application/json",
        },
      };

      let formData = new FormData();
      formData.append("image", this.promotion.image);
      formData.append("_method", "put");

      this.$axios
        .post(`${ADMIN_URL}/promotions/1`, formData, config)
        .then((response) => {
          console.log("Success", response);
          currentObj.success = response.data.success;
          console.log(response.data);
          if (response.data.success) {
            this.$swal("Success", response.data.message, "success");
          } else {
            this.$swal("Error", response.data.message, "error");
          }
        })
        .catch((error) => {
          console.log("Error  ... ", error.response);
          currentObj.output = error;
          this.$swal("Error", error.response.message, "error");
        });
    },
  },
};
</script>

<style scoped>
</style>
